import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const startSoftwareInitialization = () => ({
    type: actionTypes.SOFTWARE_START_INITIALIZATION
});

export const getProtocolList = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_PROTOCOLS
    },
    method: handlers.GET_ALL_PROTOCOLS,
    tabId: 0
});

export const getFileTransferInFormats = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_IN_FORMATS
    },
    method: handlers.GET_ALL_IN_FORMATS,
    tabId: 0
});

export const getFileTransferOutFormats = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_OUT_FORMATS
    },
    method: handlers.GET_ALL_OUT_FORMATS,
    tabId: 0
});

export const testProtocolConnection = (protocol, protocolOptions) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_TEST_PROTOCOL,
        params: {
            protocol: protocol,
            protocolOptions: protocolOptions
        }
    },
    method: handlers.TEST_PROTOCOL,
    tabId: 0
});

export const enableProduct = (productId, enabled) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ENABLE_PRODUCT,
        params: {
            productId: productId,
            enabled: enabled
        }
    },
    method: handlers.ENABLE_PRODUCT,
    tabId: 0
});

export const enableFandeck = (fandeckId, enabled) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ENABLE_FANDECK,
        params: {
            fandeckId: fandeckId,
            enabled: enabled
        }
    },
    method: handlers.ENABLE_FANDECK,
    tabId: 0
});

export const getAllTintometricSystems = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_TINTOMETRIC_SYSTEMS
    },
    method: handlers.GET_ALL_TINTOMETRIC_SYSTEMS,
    tabId: 0
});

export const getTintometricSystemIcon = (tintometricSystemId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_TINTOMETRIC_SYSTEM_ICON,
        params: {
            tintometricSystemId: tintometricSystemId
        }
    },
    method: handlers.GET_TINTOMETRIC_SYSTEM_ICON,
    tabId: 0,
    next: tintometricSystemId
});

export const fileTransferFinished = () => ({
    type: actionTypes.FILE_TRANSFER_FINISHED
});
